import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Hero meta row for legal pages — label + value pairs.
 * Pulls items from t(key, { returnObjects: true }).
 * Each item: { label, value }. Label rendered mono; value Fraunces 600.
 */
export default function LegalMetaRow({ i18nKey, testId = "legal-meta-row" }) {
    const { t } = useTranslation();
    const items = t(i18nKey, { returnObjects: true }) || [];
    return (
        <div className="legal-meta-row" data-testid={testId}>
            {items.map((it, i) => (
                <div className="legal-meta-item" key={i}>
                    <div className="legal-meta-label mono">{it.label}</div>
                    <div className="legal-meta-value">{it.value}</div>
                </div>
            ))}
        </div>
    );
}
